module.exports = __webpack_public_path__ + "static/check6-af24a460750d0568cc5477bcc38edc01.png";